<template>

    <div>

        <h1 class="text-base">Search</h1>

        <buckets :q="query" :theme="theme" :source="source" @clear="clear" @source="setSource"></buckets>

        <loading v-show="loading"></loading>

        <div v-if="!loading">

            <ul class="list-reset overflow-y-auto bg-white rounded shadow">
                <li v-for="item in search.indicators" class="border-b">
                    <a
                            @click="$emit('database', item.id)"
                            class="cursor-pointer hover:bg-blue-lighter pl-4 lg:pl-8 pr-4 py-4 lg:py-8 text-black no-underline block flex justify-between"
                    >
                        <div class="w-4/5 lg:pr-8 pr-4">
                            <p class="font-semibold leading-normal">
                                <i class="fa fa-fw fa-database text-blue-dark"></i>
                                <span v-html="item.headline"></span>
                            </p>
                            <p class="pt-2 text-sm text-green" v-for="theme in item.themes">
                                {{ theme }}
                            </p>
                            <p class="pt-4" v-html="item.body"></p>
                            <!--<div class="flex pt-4 items-baseline">


                                <p class="text-sm text-grey-dark mr-4">
                                    Series
                                    {{ item.statistics.series_count }}
                                </p>

                            </div>-->
                        </div>


                        <div class="flex flex-1 text-right">
                            <div class="w-full pr-4">
                                <p class="text-xs text-grey uppercase tracking-wide lg:pr-4">
                                    Range</p>
                                <p class="text-sm pt-2">
                                    {{ item.begin | limit }}
                                    -
                                    {{ item.end | limit }}
                                </p>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>

        <div class="mt-4 text-center p-4" v-show="response.last_page > 1">

            <a class="p-2" @click="prev" v-show="response.prev_page_url">
                <i class="fa fa-chevron-left"></i> prev
            </a>

            <span class="p-2 text-bold">{{ page }} / {{ response.last_page }}</span>

            <a class="p-2" @click="next" v-show="response.next_page_url">
                next <i class="fa fa-chevron-right"></i>
            </a>

        </div>

    </div>

</template>

<script>
    import Buckets from "./Search/Buckets";

    export default {
        name: "LibrarySearch",
        components: {Buckets},
        props: ['query'],

        data: () => ({
            theme: 'all',
            source: 'all',
            response: {},
            page: 1,
            loading: false,
            search: {
                indicators: [],
            },
        }),

        watch: {
            query() {
                this.page = 1;
                this.load();
            },
            theme() {
                this.page = 1;
            },
            source() {
                this.page = 1;
            }
        },

        filters: {
            limit: function (value) {
                return value.substring(0, 4);
            },
        },

        created() {
            this.load();
        },

        methods: {
            next() {
                this.page++;
                this.load();
            },
            prev() {
                this.page--;
                this.load();
            },
            clear() {
                this.source = 'all';
                this.theme = 'all';
                this.load();
            },
            setSource(source) {
                this.source = source;
                this.load();
            },
            load() {
                if (this.query.length === 0) {
                    return;
                }

                this.loading = true;
                let that = this;
                http.get('/api/v1/indicators/search/' + this.query, {
                    params: {
                        source: this.source,
                        theme: this.theme,
                        page: this.page,
                    }
                }).then((response) => {
                    that.search.indicators = response.data.data;
                    that.response = response.data;
                    that.loading = false;
                });
            },

        }
    }
</script>

<style scoped>

</style>
